import React, { useEffect, useState } from 'react';

const Loader = ({ done }) => {
  const [visible, setVisible] = useState(true);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (done) {
      const t1 = setTimeout(() => setVisible(false), 100);
      const t2 = setTimeout(() => setHidden(true), 900);
      return () => { clearTimeout(t1); clearTimeout(t2); };
    }
  }, [done]);

  if (hidden) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center pointer-events-none"
      style={{
        background: '#1B0F0D',
        transform: visible ? 'translateY(0)' : 'translateY(-100%)',
        transition: 'transform 800ms cubic-bezier(0.76, 0, 0.24, 1)'
      }}
    >
      <div className="text-center">
        <div
          className="font-label text-[0.7rem] text-[var(--terracotta)] mb-6 tracking-[0.4em]"
          style={{ animation: 'fadeIn 600ms 100ms both' }}
        >
          PORTFOLIO
        </div>
        <div
          className="font-display text-[clamp(2.5rem,7vw,5rem)] text-[var(--cream)]"
          style={{ animation: 'fadeUp 900ms 200ms both cubic-bezier(0.16, 1, 0.3, 1)' }}
        >
          Alifia <span style={{ fontStyle: 'italic', fontWeight: 300 }}>Povlsen</span>
        </div>
        <div className="mt-10 w-48 h-[1px] bg-[var(--cream)]/15 mx-auto relative overflow-hidden">
          <div
            className="absolute top-0 left-0 h-full bg-[var(--terracotta)]"
            style={{ animation: 'loadBar 1.4s 0.3s cubic-bezier(0.76, 0, 0.24, 1) forwards' }}
          />
        </div>
      </div>
      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes loadBar { from { width: 0%; } to { width: 100%; } }
      `}</style>
    </div>
  );
};

export default Loader;
